export default __webpack_public_path__ + "static/media/mobile-app.24c5d20d.png";